import { KTIcon } from "../../../../_metronic/helpers";

const PaymentHistoryModalHeader = ({
  setOpenPaymentHistoryModal,
  selectedBookingId,
  setSelectedBookingId
}) => {
  return (
    <div className="modal-header">
      <div>
      <h2 className="fw-bolder">{`Payment History for #${selectedBookingId?.reservation_code}`}</h2>
      </div>
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setOpenPaymentHistoryModal(false)
          setSelectedBookingId(null)
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
    </div>
  );
};

export { PaymentHistoryModalHeader };
